module.exports = __webpack_public_path__ + "img/pd_mask.62ba605c.png";